import {assert} from 'assert-ts';
import clone from 'lodash/clone';
import isEqual from 'lodash/isEqual';
import type {PartValueModifier, ThesaurusValue} from 'schemaDefinition/types';
import {isNullish} from 'schemaDefinition/functions';
import {isWorkValue} from 'services/utils/functions/isWorkValue';
import {mapEducationLevelToGrepYearLevel} from 'schemas/valueModifiers/mapper/educationLevelToGrepYearLevel';

/**
 * Updates grep year level codes based on the education level codes.
 */
export const educationLevelModifier: PartValueModifier = ({
  value,
  part,
  oldValue,
  entityValue,
}) => {
  assert(
    isNullish(value) || Array.isArray(value),
    'educationLevelModifier: value must be null or an array',
    {value, part},
  );
  assert(
    isNullish(oldValue) || Array.isArray(oldValue),
    'educationLevelModifier: oldValue must be null or an array',
    {oldValue, part},
  );
  assert(
    isWorkValue(entityValue),
    'educationLevelModifier: entityValue must be Work',
    {entityValue, part},
  );

  /*
    If level is added
      - add grep if exist

    If level is removed
      - remove grep if exist
      - check if other grep should be added instead?
 */

  const addedValues = ((value ?? []) as string[]).filter(
    item => !((oldValue ?? []) as string[]).includes(item),
  );
  const removedValues = ((oldValue ?? []) as string[]).filter(
    item => !((value ?? []) as string[]).includes(item),
  );

  const addedValuesAsGrepValues = addedValues
    .map(mapEducationLevelToGrepYearLevel)
    .filter(a => a) as string[];

  const removedValuesAsGrepValues = removedValues
    .map(mapEducationLevelToGrepYearLevel)
    .filter(a => a) as string[];

  const originalGrep = entityValue.grep ?? [];
  const grep: ThesaurusValue = clone(originalGrep);
  addedValuesAsGrepValues.forEach(grepValue => {
    if (!grep.includes(grepValue)) {
      grep.push(grepValue);
    }
  });
  removedValuesAsGrepValues.forEach(grepValue => {
    const index = grep.indexOf(grepValue);
    if (index !== -1) {
      grep.splice(index, 1);
    }
  });

  if (!isEqual(originalGrep, grep)) {
    return {
      value,
      sideEffects: [
        {
          valuePath: 'grep',
          value: grep,
        },
      ],
    };
  }

  return {value};
};
